import LineItem, { ILineItemAPI } from '@/common/models/lineitem/LineItem';

import MobileLineItem, { IMobileLineItemAPI } from './MobileLineItem';

export interface IMobileLineItemLineItemAPI {
  mobilelineitemlineitem_id: number;
  lineitem_id: number;
  mobilelineitem_id: number;
  lineitem?: ILineItemAPI;
  mobilelineitem?: IMobileLineItemAPI;
}

export default class MobileLineItemLineItem {
  id: number;
  lineItemID: number;
  mobileLineItemID: number;
  lineItem?: LineItem;
  mobileLineItem?: MobileLineItem;

  constructor(id = -1, lineItemID, mobileLineItemID, lineItem = null, mobileLineItem = null) {
    this.id = id;
    this.lineItemID = lineItemID;
    this.mobileLineItemID = mobileLineItemID;
    this.lineItem = lineItem;
    this.mobileLineItem = mobileLineItem;
  }

  static fromApi(apiObject: IMobileLineItemLineItemAPI) {
    return new MobileLineItemLineItem(
      apiObject.mobilelineitemlineitem_id,
      apiObject.lineitem_id,
      apiObject.mobilelineitem_id,
      apiObject.lineitem ? LineItem.fromApi(apiObject.lineitem) : null,
      apiObject.mobilelineitem ? MobileLineItem.fromApi(apiObject.mobilelineitem) : null,
    );
  }

  toApi(): IMobileLineItemLineItemAPI {
    return {
      mobilelineitemlineitem_id: this.id >= 0 ? this.id : undefined,
      lineitem_id: this.lineItemID,
      mobilelineitem_id: this.mobileLineItemID,
    };
  }
}
